import Vue from 'vue';
import './plugins/axios'
import store from './store'
import App from './App';
import { router } from './router';
import Navigation from 'vue-navigation'
// import VueClipboard from 'vue-clipboard2'
import './permission'

import 'vant/lib/index.css';
import { Button } from 'vant';
Vue.use( Button );

import animate from 'animate.css'

import { getAllUrlParams } from './utils/auth';

Vue.use(Navigation, {router})
// Vue.use(VueClipboard)

// 调试
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

new Vue({
router,
el: '#app',
store,
render: h => h(App)
}).$mount('#app')
